<template>
    <contact-form 
        :header="header"
        :text="text"
    />
</template>

<script>
import ContactForm from '@/components/ContactForm.vue';
export default {
    components: {
        ContactForm
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        header() {
            return this.$validateText(this.slice.primary.title) 
                ? this.$prismic.asText(this.slice.primary.title) 
                : null;
        },
        text() {
            return this.$validateText(this.slice.primary.text) 
                ? this.$prismic.asHtml(this.slice.primary.text) 
                : null;
        }
    }
};
</script>